export type NotificationEventType =
  | 'lead.assigned'
  | 'lead.campaign_entered'
  | 'followup.handoff'
  | 'calendar.ai_created'
  | 'opportunity.pipeline_changed'
  | 'opportunity.won'
  | 'opportunity.lost'
  | 'conversation.opened'
  | 'conversation.closed'
  | 'whatsapp.connected';

export type AppNotification = {
  id: string;
  eventType: NotificationEventType;
  title: string;
  body: string;
  createdAt: string;
  readAt: string | null;
  contactId?: string | null;
  opportunityId?: string | null;
  accountId?: string;
};

export type NotificationSettingsState = {
  whatsappEnabled: boolean;
  events: Record<NotificationEventType, boolean>;
};

export const DEFAULT_NOTIFICATION_SETTINGS: NotificationSettingsState = {
  whatsappEnabled: false,
  events: {
    'lead.assigned': false,
    'lead.campaign_entered': false,
    'followup.handoff': false,
    'calendar.ai_created': false,
    'opportunity.pipeline_changed': false,
    'opportunity.won': false,
    'opportunity.lost': false,
    'conversation.opened': false,
    'conversation.closed': false,
    'whatsapp.connected': false,
  },
};
